import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "MANAGE_FORMS/MANAGE_STATE_FORM";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },
        setSelectedStateForms: (state, action) => {
            state.selectedStateForms = action.payload
        },
        setSelectedStateFormsStates: (state, action) => {
            const { name, value } = action.payload
            state.stateFormStates[name] = value;
        },
        setStateFilingGridData: (state, action) => {
            state.stateFilingGridData = action.payload
        },
        setDownloadAllPdfModal: (state, action) => {
            state.downloadAllPdfModal = action.payload
        },
        setBlockStateFilingModal: (state, action) => {
            state.blockStateFilingModal = action.payload
        },
        setBlockStateFilingData: (state, action) => {
            state.blockStateFilingData = action.payload
        },
        setClickedActionButtonIndex: (state, action) => {
            state.clickedActionButtonIndex = action.payload
        },
        setStateForms: (state, action) => {
            state.stateForms = action.payload
        },
        setDownloadStatePdfCheckboxStates: (state, action)=>{
            state.downloadStatePdfCheckboxStates = { ...state.downloadStatePdfCheckboxStates, ...action.payload }
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setPayerDropdownPagination: (state, action) => {
            state.payerDropdownPagination = { ...state.payerDropdownPagination, ...action.payload }
        },
    },
    initialReducerState: {
        clickedActionButtonIndex: null,
        stateForms: [],
        selectedStateForms: [],
        stateFilingGridData: [],
        stateFormStates: {
            StatePayer: { value: "", label: "" },
            StateFormName: { value: "", label: "" },
            StateTaxYear: { value: "", label: "" },
        },
        blockStateFilingData: {},

        paginationState: {
            PageNumber: 1,
            PageSize: 10,
            FilterText: "",
            IsDesc: true,
            IdNumber: "",
            Skip: 0,
            totalRecipients: 10,
        },

        payerDropdownPagination: {
            PageNumber: 1,
            PageSize: 10,
        },

        //modals
        downloadAllPdfModal: false,
        blockStateFilingModal: false,
        downloadStatePdfCheckboxStates: {
            mergeCopies: false
        },
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
    }
})

export const { setPaginationState, setSelectedStateForms, setSelectedStateFormsStates, setStateFilingGridData, setDownloadAllPdfModal, setBlockStateFilingModal, setBlockStateFilingData, setClickedActionButtonIndex, setStateForms, setDownloadStatePdfCheckboxStates, setLoadingState, setPayerDropdownPagination } = actions; 
